export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">联系我们</h2>
        <p className="text-sm text-foreground-500 mb-8">欢迎投稿、合作咨询或反馈建议</p>

        <div className="bg-background-100 rounded-2xl p-8 md:p-10">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-10">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-primary-500 text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400">投稿邮箱</div>
                <div className="text-sm font-semibold text-foreground-800">submit@aimanhua.com</div>
              </div>
            </div>
            <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-accent-500 text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400">官方微信</div>
                <div className="text-sm font-semibold text-foreground-800">爱漫画官方</div>
              </div>
            </div>
            <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-question-answer-line text-secondary-500 text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400">在线反馈</div>
                <div className="text-sm font-semibold text-foreground-800">7×24 小时响应</div>
              </div>
            </div>
          </div>

          <p className="mt-8 text-xs text-foreground-400 leading-relaxed">
            如果您有原创漫画作品希望在我们平台发布，或对爱漫画有任何意见与建议，欢迎随时联系我们。我们的编辑团队会在48小时内回复您的来信。
          </p>
        </div>
      </div>
    </section>
  );
}